import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AllMenu } from 'src/app/model/menu-item/existingItems';
import { User } from 'src/app/model/users/users';
import {
  APIUrls,
  WebConfigurationService,
} from '../common/web-configuration.service';

@Injectable({
  providedIn: 'root',
})
export class UserService extends WebConfigurationService {
  private username = new BehaviorSubject('');
  sharedUsername = this.username.asObservable();
  public static restricted: string[] = [];
  public static isAdmin: boolean = false;
  public static idUser: number = 0;
  public webtoken: string = '';

  @Output() userLoggedInEvent = new EventEmitter<string[]>();

  constructor(protected http: HttpClient) {
    super(http);
  }

  isRestricted(): boolean {
    if (UserService.restricted) {
      return UserService.restricted.length > 0;
    }
    return false;
  }

  isAdmin(): boolean {
    return UserService.isAdmin;
  }

  getIdUser(): number {
    return UserService.idUser;
  }

  /* Set the bearer token */
  public onLogin(data: any) {
    // console.log(data)
    WebConfigurationService.bearerToken = data.token;
    UserService.restricted = data.restricted;
    localStorage.setItem('restricted', data.restricted);
    UserService.isAdmin = data.isAdmin;
    localStorage.setItem('isAdmin', data.isAdmin);
    UserService.idUser = data.idUser;
    localStorage.setItem('idUser', data.idUser);

    if (data.restricted) {
      // User has a restriction array
      this.userLoggedInEvent.emit(data.restricted);
    } else {
      // User has no restrictions, he can access all menu items
      this.userLoggedInEvent.emit(AllMenu.getMenuLinks());
    }

    this.save();
  }

  /**
   * Emit the fact that user is not logged-in
   */
  public notLoggedYet() {
    this.userLoggedInEvent.emit(['/login']);
  }

  /**
   * Post a Login
   * @returns  an Observable
   */
  public postLogin(formData: FormData): Observable<any> {
    console.log('[UserService] login URL:', this.getLoginUrl());
    return this.http.post(this.getLoginUrl(), formData);
  }

  public changeUsername(username: string) {
    this.username.next(username);
  }

  public usersList(): Observable<User[]> {
    return this.authGetObs(APIUrls.getUsersListUrl());
  }

  public deleteUser(login: string) {
    console.log(this.getUserUrl(login));
    return this.authDelObs(this.getUserUrl(login));
  }

  public updateUser(login: string) {
    // return this.authPutObs( this.getUserUrl( login ));
  }

  /**
   * saves current user & token into local storage.
   */
  protected save(): void {
    if (WebConfigurationService.bearerToken) {
      localStorage.setItem(
        'userToken',
        JSON.stringify(WebConfigurationService.bearerToken)
      );
    }
  }
}
